import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { Home } from './pages/Home';
import { BrandPage } from './pages/BrandPage';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3farh3x632479">
      <div className="min-h-screen w-full bg-white font-heading text-slate-900" data-id="element-1" data-mp="3fa850x346a15">
        <Header data-id="element-2" data-mp="2rkdw2qlx15m6" />
        <main data-id="element-3" data-mp="2rlyreig20sl3">
          <Routes data-id="element-4" data-mp="2rlp10tr3kjev">
            <Route path="/" element={<Home data-id="element-6" data-mp="2mlua4q7bnttt" />} data-id="element-5" data-mp="2rl6xrd60p4xg" />
            <Route path="/:brandId" element={<BrandPage data-id="element-8" data-mp="2mndqegsza4vl" />} data-id="element-7" data-mp="2mmcb204xiw82" />
          </Routes>
        </main>
        <Footer data-id="element-9" data-mp="31b8jvzet8d9q" />
      </div>
    </BrowserRouter>;
}